import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import PriceInformationCard from "../components/PriceInformationCard";
import ApartmentInputCard from "../components/Cards/ApartmentInputCard";
import ApartmentInsuranceCard from "../components/Cards/ApartmentInsuranceCard";
import OtherInformationCard from "../components/Cards/OtherInformationCard";
import PageStepCard from '../components/Cards/PageStepsCard'

import history from "../router/history";
import { PageHeading } from "../components/PageHeading";
import { setCurrentStep, setStepAndContact } from "../reducers/stepsAction";

import { setHouseCompany } from '../reducers/simpleAction';

class ApartmentPage extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.setCurrentStep(2);
  }
  
  render() {
    function calculateAge(dob) {
      var today = new Date();
      var dobFormat = dob.substring(0,4) + "/" + dob.substring(4,6) + "/" + dob.substring(6,8);
      var birthDate = new Date(dobFormat);  // create a date object directly from `dob1` argument
      var age_now = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
      {
          age_now--;
      }
      return age_now;
    }

    this.props.setHouseCompany(this.props.match.params.id);
    
    const mandatoryField = "Detta fält är obligatoriskt";

    let nrPersonalAccidentInsurances = this.props.apartment_information.selected_number_personal_accident_insurances
    let paymentSelection = this.props.paymentSelection;
    let continueUrl = "/kund/" + this.props.housingCompanyPath + "/summary";
    let validationSchema = Yup.object().shape({

      landlord: Yup.string().required(mandatoryField),
      rooms: Yup.string().nullable().required(mandatoryField),
      insuranceStart: Yup.string().required(mandatoryField),
      selected_payment_method: (paymentSelection.length > 1) ? Yup.string().nullable().required(mandatoryField) : null,
      selected_additional_jewelry_insurance: Yup.bool().nullable().required(mandatoryField),
      
      privateAccidentInsurance: this.props.apartment_information.personal_accident_insurance ? Yup.string().required(mandatoryField) : null,

      privateInsurancePersonSsn1: nrPersonalAccidentInsurances > 0 ? Yup.string()
        .matches(/^((19|20).)/, { message: "Måste vara född på 1900- eller 2000-talet.", })
        .matches(/^\d{12}$/, { message: "Personnummer måste innehålla 12 tecken." })
        .test('test-socialSecurityNumber1', "Person får inte vara äldre än 69 år gammal.", function(input) {
          if(input === undefined) {
            return false;
          }
          let value = input.toString();
          if(value.length > 7) {
            if(calculateAge(value) > 69) {
              return false;
            }
          }
          return true;
        })
        .required("Detta fält är obligatoriskt") : null,
      privateInsurancePersonName1: nrPersonalAccidentInsurances > 0 ? Yup.string().required(mandatoryField) : null,

      privateInsurancePersonSsn2: nrPersonalAccidentInsurances > 1 ? Yup.string()
        .matches(/^((19|20).)/, { message: "Måste vara född på 1900- eller 2000-talet.", })
        .matches(/^\d{12}$/, { message: "Personnummer måste innehålla 12 tecken." })
        .test('test-socialSecurityNumber2', "Person får inte vara äldre än 69 år gammal.", function(input) {
          if(input === undefined) {
            return false;
          }
          let value = input.toString();
          if(value.length > 7) {
            if(calculateAge(value) > 69) {
              return false;
            }
          }
          return true;
        })
        .required("Detta fält är obligatoriskt") : null,
      privateInsurancePersonName2: nrPersonalAccidentInsurances > 1 ? Yup.string().required(mandatoryField) : null,

      privateInsurancePersonSsn3: nrPersonalAccidentInsurances > 2 ? Yup.string()
        .matches(/^((19|20).)/, { message: "Måste vara född på 1900- eller 2000-talet.", })
        .matches(/^\d{12}$/, { message: "Personnummer måste innehålla 12 tecken." })
        .test('test-socialSecurityNumber3', "Person får inte vara äldre än 69 år gammal.", function(input) {
          if(input === undefined) {
            return false;
          }
          let value = input.toString();
          if(value.length > 7) {
            if(calculateAge(value) > 69) {
              return false;
            }
          }
          return true;
        })
        .required("Detta fält är obligatoriskt") : null,
      privateInsurancePersonName3: nrPersonalAccidentInsurances > 2 ? Yup.string().required(mandatoryField) : null,

      privateInsurancePersonSsn4: nrPersonalAccidentInsurances > 3 ? Yup.string()
        .matches(/^((19|20).)/, { message: "Måste vara född på 1900- eller 2000-talet.", })
        .matches(/^\d{12}$/, { message: "Personnummer måste innehålla 12 tecken." })
        .test('test-socialSecurityNumber4', "Person får inte vara äldre än 69 år gammal.", function(input) {
          if(input === undefined) {
            return false;
          }
          let value = input.toString();
          if(value.length > 7) {
            if(calculateAge(value) > 69) {
              return false;
            }
          }
          return true;
        })
        .required("Detta fält är obligatoriskt") : null,
      privateInsurancePersonName4: nrPersonalAccidentInsurances > 3 ? Yup.string().required(mandatoryField) : null,

      privateInsurancePersonSsn5: nrPersonalAccidentInsurances > 4 ? Yup.string()
        .matches(/^((19|20).)/, { message: "Måste vara född på 1900- eller 2000-talet.", })
        .matches(/^\d{12}$/, { message: "Personnummer måste innehålla 12 tecken." })
        .test('test-socialSecurityNumber5', "Person får inte vara äldre än 69 år gammal.", function(input) {
          if(input === undefined) {
            return false;
          }
          let value = input.toString();
          if(value.length > 7) {
            if(calculateAge(value) > 69) {
              return false;
            }
          }
          return true;
        })
        .required("Detta fält är obligatoriskt") : null,
      privateInsurancePersonName5: nrPersonalAccidentInsurances > 4 ? Yup.string().required(mandatoryField) : null,
    });

    if(this.props.contact_information.social_security_number === undefined || this.props.contact_information.social_security_number === "") {
      //history.push("/kund/" + this.props.match.params.id);
    }

    return (
      <div>
        <PageHeading title="Köp hemförsäkring" customer="true" history={this.props.history} urlParams={this.props.match.params} />
        <div className="row">
          <div className="col-lg-8">
            <Formik
              initialValues={{
                landlord: this.props.apartment_information.landlord,
                rooms: this.props.apartment_information.number_of_rooms,
                insuranceStart: this.props.apartment_information.insurance_start,
                security_door: this.props.apartment_information.security_door,
                comprehensive_insurance: this.props.apartment_informationcomprehensive_insurance,
                increased_travel_protection: this.props.apartment_information.increased_travel_protection,
                personal_accident_insurance: this.props.apartment_information.personal_accident_insurance,
                tenant_insurance: this.props.apartment_information.tenant_insurance,
                small_boats_insurance: this.props.apartment_information.small_boats_insurance,
                privateAccidentInsurance: this.props.apartment_information.number_personal_accident_insurances,
                
                privateInsurancePersonSsn1: this.props.apartment_information.first_personal_accident_insurances_ssn,
                privateInsurancePersonName1: this.props.apartment_information.first_personal_accident_insurances_name,

                privateInsurancePersonSsn2: this.props.apartment_information.second_personal_accident_insurances_ssn,
                privateInsurancePersonName2: this.props.apartment_information.second_personal_accident_insurances_name,

                privateInsurancePersonSsn3: this.props.apartment_information.third_personal_accident_insurances_ssn,
                privateInsurancePersonName3: this.props.apartment_information.third_personal_accident_insurances_name,

                privateInsurancePersonSsn4: this.props.apartment_information.fourth_personal_accident_insurances_ssn,
                privateInsurancePersonName4: this.props.apartment_information.fourth_personal_accident_insurances_name,

                privateInsurancePersonSsn5: this.props.apartment_information.fifth_personal_accident_insurances_ssn,
                privateInsurancePersonName5: this.props.apartment_information.fifth_personal_accident_insurances_name,
                
                otherInformation: this.props.apartment_information.other_information,
                contactMe: this.props.apartment_information.contact_me,
                selectedContactMeArea: this.props.apartment_information.selected_contact_me_area,
                wantInformationOn: this.props.apartment_information.want_information_on,
                selected_payment_method: this.props.apartment_information.selected_payment_method,
                selected_additional_jewelry_insurance: this.props.apartment_information.selected_additional_jewelry_insurance || ''
              }}
              validationSchema={validationSchema}
              onSubmit={fields => {
                this.props.setCurrentStep(3);
                this.props.history.push(continueUrl);
              }}>
                {(formikProps) =>
                    <Form>
                      <ApartmentInputCard {...formikProps} />
                      <ApartmentInsuranceCard {...formikProps} />
                      <OtherInformationCard {...formikProps} />
                      
                      <PageStepCard {...formikProps} history={this.props.history} step="2" />
                    </Form>
                } 
              </Formik>
          </div>
          
          <div className="col-lg-4">
            <div className="sidebar">
              <PriceInformationCard />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    contact_information: state.contactReducer.contact_information,
    apartment_information: state.apartmentReducer.apartment_information,
    housingCompanyPath: state.simpleReducer.housingCompanyPath,
    customerSection: state.simpleReducer.customerSection,
    currentStep: state.stepsReducer.currentStep,
    paymentSelection: state.simpleReducer.textSections.paymentSelection,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentStep: bindActionCreators(setCurrentStep, dispatch),
    setStepAndContact: bindActionCreators(setStepAndContact, dispatch),
    setHouseCompany: bindActionCreators(setHouseCompany, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApartmentPage);
